import { createGlobalStyle } from 'styled-components';
import globals from './globals';
import grid from './utils/grid';
import icons from './utils/icons';
import margins from './utils/margins';
import paddings from './utils/paddings';
import misc from './utils/misc';
import text from './utils/text';
import visibility from './utils/visibility';
import { btn } from '../styling/mixins/buttons';

export const GlobalStyle = createGlobalStyle`
  ${grid}
  ${misc}
  ${text}
  ${visibility}
  ${icons}
  ${margins}
  ${paddings}
  ${globals}

  #c-inr #c-bns #c-p-bn,
  #c-vln #cs #c-s-in #s-inr #s-bns #s-all-bn {
    ${btn('secondary', 'medium')};
    display: inline-flex;
  }
    
  #c-inr #c-bns #c-s-bn, 
  #c-vln #cs #c-s-in #s-inr #s-bns #s-rall-bn,
  #c-vln #cs #c-s-in #s-inr #s-bns #s-sv-bn {
    ${btn('primary', 'medium')};
    display: inline-flex;
  }
`;
